import { render } from "./Stock.vue?vue&type=template&id=5fde1af7&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"

import "./Stock.vue?vue&type=style&index=0&id=5fde1af7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fde1af7"]])

export default __exports__